<template>
  <v-app
    id="app"
    :class="{isPrintLayout}"
  >
    <v-progress-linear
      class="app-loader"
      :active="appLoader.visibility"
      :color="appLoader.color"
      :indeterminate="true"
      height="4"
    ></v-progress-linear>

    <v-overlay
      :value="overlayLoader.visibility"
      class="overlay-loader"
    >
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>

    <main
      v-if="!noLayoutRequired"
      :class="['naj-app', { 'sidebar-small': sideNavVisibility, 'side-nav-collapsed': collapsed }]"
    >
      <!-- Settings Box -->
      <naj-settings-box v-if="false"></naj-settings-box>

      <!-- this div for dynamic twain plugin(scanner), don't remove it  -->
      <div id="dwtcontrolContainer" />

      <!-- Content -->
      <div
        class="naj-content"
        :class="settingsClasses"
      >
        <div class="content-contents">
          <naj-breadcrumb class="px-10 mt-7"></naj-breadcrumb>

          <!-- <h1 class="naj-heading" v-if="isPageHeadingVisible">{{ currentPageTitle }}</h1> -->

          <router-view></router-view>
        </div>
      </div>
    </main>
  </v-app>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import NajSettingsBox from '@/modules/global/components/naj-settings-box';
import { resetScroll } from '@/helpers/utils';
import NajBreadcrumb from '@/modules/global/components/naj-breadcrumb';
import { getThemeColor, updateAppVariables } from './appTheme';
const { mapState, mapGetters, mapActions } = createNamespacedHelpers('GlobalModule');
export default {
  name: 'NajApp',
  components: {
    NajSettingsBox,
    NajBreadcrumb,
  },
  data() {
    return { isPrintLayout: false };
  },
  mounted() {
    this.checkLayout();
    this.getQaimConfg();
    this.updateUIFrameWork();
    updateAppVariables();
    if (this.$route.meta && this.$route.meta.isPublic) { return; }
    this.getUserInfo();
  },
  computed: {
    ...mapState({
      sideNavVisibility: state => state.sideNav.visible,
      appSettings: state => state.appSettings,
      appLoader: state => state.appLoader,
      overlayLoader: state => state.overlayLoader,
      collapsed: state => state.sideNav.collapsed,
    }),
    ...mapGetters(['currentPageTitle']),
    noTitle() {
      return Boolean(this.$route.meta.noTitle);
    },
    noLayoutRequired() {
      return Boolean(this.$route.meta.noLayoutRequired);
    },
    settingsClasses() {
      const settings = this.appSettings;
      return Object.keys(settings).reduce(
        (classes, optionKey) => `${classes} ${settings[optionKey] || ''}`,
        ''
      );
    },
    isPageHeadingVisible() {
      // !this.noTitle && this.currentPageTitle // Old Condition
      return false;
    },
  },
  methods: {
    ...mapActions(['getUserInfo', 'getQaimConfg']),
    updateUIFrameWork() {
      const { primary, secondary, lighterPrimary } = this.$vuetify.theme.themes.light;

      const lightTheme = this.$vuetify.theme.themes.light;
      lightTheme.primary = getThemeColor('primary') || primary;
      lightTheme.secondary = getThemeColor('secondary') || secondary;
      lightTheme.lighterPrimary = getThemeColor('lighter-primary') || lighterPrimary;
    },
    checkLayout() {
      this.isPrintLayout = this.$router.history.current.name.indexOf('print') !== -1;

      this.$router.afterEach((e) => {
        this.isPrintLayout = e.name.indexOf('print') !== -1;
        resetScroll();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/scss/partials/_vars.scss';

#dwtcontrolContainer {
  display: none !important;
}

.app-loader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 500;
}

.naj-heading {
  padding: 0 0 20px;
  font-size: 22px;
  font-weight: 500;
  height: 48px;
  box-sizing: content-box;
  color: #252733;
}

.overlay-loader {
  z-index: 300 !important;
}
</style>
<style lang="scss">
#app {
  overflow: hidden;

  &.isPrintLayout {
    overflow: auto;
  }

  @media only screen and (max-width: 1024px) {
    overflow: auto !important;
  }
}

section.dashboardActions {
  overflow: hidden !important;

  @media only screen and (max-width: 1024px) {
    overflow: auto !important;
  }
}

@media (max-width: 600px) {
  .dashboardActions {
    margin-top: 0px !important;
  }
}
</style>

